import React from "react";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import { less, plus } from "Icons/index";

const ResourceAdder = ({ onChange, name, value }) => {
  return (
    <div className="flex justify-between items-center border border-solid border-[--input-border] rounded px-2 w-32">
      <ButtonIcon icon={less} disabled={value <= 5} onClick={() => onChange({ [name]: value - 1 })} />
      <div className="text-sm">{value}</div>
      <ButtonIcon icon={plus} onClick={() => onChange({ [name]: value + 1 })} />
    </div>
  );
};

export default ResourceAdder;
